import type { Card } from '../../types';

/** Attack body with a Weaken rider — composed effects, not a new type (§3). */
export const PRECISE_THRUST: Card = {
  id: 'precise-thrust',
  name: 'Precise Thrust',
  type: 'attack',
  rarity: 'rare',
  size: { w: 1, h: 2 },
  cost: [{ kind: 'min', value: 4 }],
  effects: [
    { kind: 'damage', amount: 6 },
    {
      kind: 'applyStatus',
      application: { status: 'weaken', magnitude: 2, duration: 2, target: 'opponent' },
    },
  ],
};
